import * as React from "react";
import type { TenantContext } from "./types";

/**
 * Read-only tenant context for the running request/tenant.
 *
 * Supplied by the root route loader from server-side host resolution. It is
 * presentation metadata only: data access remains enforced by database RLS
 * (`tenant_isolation` policies + `current_tenant_id()`), never by this value.
 */
const TenantCtx = React.createContext<TenantContext | null>(null);

export function TenantProvider({
  value,
  children,
}: {
  value: TenantContext | null;
  children: React.ReactNode;
}) {
  return <TenantCtx.Provider value={value}>{children}</TenantCtx.Provider>;
}

/** Current tenant context, or null when it could not be resolved. */
export function useTenant(): TenantContext | null {
  return React.useContext(TenantCtx);
}
